import React, { useState, useContext, useEffect } from 'react';
import { Button, Form, FormGroup, Row, Col, Label, Input, InputGroup, InputGroupAddon } from 'reactstrap';
import Alert from 'react-s-alert';
import moment from 'moment';

// import contexts
import { ThemeContext } from '../../contexts/ThemeContext';
import { AuthContext } from '../../contexts/AuthContext';

// import services
import GeneralService from '../../services/GeneralService';

// local imports
import GeneralNavbar from '../general/GeneralNavbar';
import Footer from '../general/Footer';
import listOfStates from '../../assets/listOfStates.json';
import listOfCities from '../../assets/listOfCities.json';
import Male from '../../assets/maleSuggestion.png';
import Female from '../../assets/femaleSuggestion.jpg';
import Message from '../general/Message';

const ProviderSignUpStep1 = props => {

    // contexts
    const { theme, colors, fontFamily, fontSize, fontWeight } = useContext(ThemeContext);
    const { user, setUser } = useContext(AuthContext);

    // states
    const [provider, setProvider] = useState({
        languages: [],
        specialities: [],
        degrees: [],
    });
    const [titles, setTitles] = useState([]);
    const [filteredCities, setFilteredCities] = useState(listOfCities);
    const [specialitiesSuggestion, setSpecialitiesSuggestion] = useState([]);
    const [languagesSuggestion, setLanguagesSuggestion] = useState([]);
    const [isError, setIsError] = useState({
        message: {
            msgBody: "",
            msgError: false
        }
    });

    // useEffects
    useEffect(() => {
        window.scrollTo(0, 0);
        // console.log('user', user);
        const temp = user.username.split(' ');
        setProvider({
            ...provider,
            title: temp.length > 0 ? temp[0] : '',
            firstName: temp.length > 1 ? temp[1] : '',
            lastName: temp.length > 2 ? temp[2] : '',
            email: user.email,
            country: 'India'
        })
    }, [])

    useEffect(() => {
        if (isError.message.msgError) {
            window.scrollTo(0, 0);
        }
    }, [isError.message]);

    useEffect(() => {
        GeneralService.getProfileSuggestions()
            .then(data => {
                try {
                    setTitles(data.userTitles);
                    setSpecialitiesSuggestion(data.providerSpecialities);
                    setLanguagesSuggestion(data.providerLanguages);
                } catch (err) {
                    Alert.error("Some error occured, please try again later or report support team.", {
                        position: 'top-right',
                        effect: 'slide'
                    });
                    // GeneralService.logError('at Provider ProviderProfile useEffect', 'Error in try catch block', err.stack);
                }
            });
    }, []);

    const handleChange = e => {
        try {
            setProvider({ ...provider, [e.target.name]: e.target.value });
        } catch (err) {
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            // GeneralService.logError('at Provider ProviderProfile handleChange', 'Error in try catch block', err.stack);
        }
    }

    const handleAddSpeciality = e => {
        try {
            let index = document.getElementById("speciality").value;
            const value = specialitiesSuggestion[index];
            let tempArray = [...specialitiesSuggestion];
            tempArray.splice(index, 1);
            if (index) {
                setProvider({ ...provider, specialities: [...provider.specialities, value] });
                setSpecialitiesSuggestion(tempArray);
            }
        } catch (err) {
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            // GeneralService.logError('at Provider ProviderProfile handleAddSpeciality', 'Error in try catch block', err.stack);
        }
    }

    const handleRemoveSpeciality = e => {
        try {
            let index = e.target.id;
            const value = provider.specialities[index];
            let tempArray = [...provider.specialities];
            tempArray.splice(e.target.id, 1);
            if (index) {
                setProvider({ ...provider, specialities: tempArray });
                setSpecialitiesSuggestion([...specialitiesSuggestion, value]);
            }
        } catch (err) {
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            // GeneralService.logError('at Provider ProviderProfile handleRemoveSpeciality', 'Error in try catch block', err.stack);
        }
    }

    const handleAddLanguages = e => {
        try {
            let index = document.getElementById("languages").value;
            const value = languagesSuggestion[index];
            let tempArray = [...languagesSuggestion];
            tempArray.splice(index, 1);
            if (index) {
                setProvider({ ...provider, languages: [...provider.languages, value] });
                setLanguagesSuggestion(tempArray);
            }
        } catch (err) {
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            // GeneralService.logError('at Provider ProviderProfile handleAddLanguages', 'Error in try catch block', err.stack);
        }
    }

    const handleRemoveLanguages = e => {
        try {
            let index = e.target.id;
            const value = provider.languages[index];
            let tempArray = [...provider.languages];
            tempArray.splice(e.target.id, 1);
            if (index) {
                setProvider({ ...provider, languages: tempArray });
                setLanguagesSuggestion([...languagesSuggestion, value]);
            }
        } catch (err) {
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            // GeneralService.logError('at Provider ProviderProfile handleRemoveLanguages', 'Error in try catch block', err.stack);
        }
    }

    const handleDegreeKeydown = e => {
        try {
            if (e.keyCode === 13) {
                e.preventDefault();
                handleAddDegree();
            }
        } catch (err) {
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            // GeneralService.logError('at Provider ProviderProfile handleDegreeKeydown', 'Error in try catch block', err.stack);
        }
    }

    const handleAddDegree = e => {
        try {
            let element = document.getElementById("degree");
            const value = element.value;
            if (value) {
                setProvider({ ...provider, degrees: [...provider.degrees, value] });
                element.value = "";
            }
        } catch (err) {
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            // GeneralService.logError('at Provider ProviderProfile handleAddDegree', 'Error in try catch block', err.stack);
        }
    }

    const handleRemoveDegree = e => {
        try {
            let tempArray = [...provider.degrees];
            tempArray.splice(e.target.id, 1);
            setProvider({ ...provider, degrees: tempArray });
        } catch (err) {
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            // GeneralService.logError('at Provider ProviderProfile handleRemoveDegree', 'Error in try catch block', err.stack);
        }
    }

    const handleCityChange = e => {
        try {
            if (e.target.selectedIndex == 0) {
                document.getElementById("state").selectedIndex = 0;
            } else {
                const index = e.target.selectedIndex - 1;
                const stateIndex = Number(filteredCities[index].state_id);
                document.getElementById("state").selectedIndex = stateIndex;
                setProvider({ ...provider, city: filteredCities[index].name });
            }
        } catch (err) {
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            // GeneralService.logError('at Provider ProviderProfile handleCityChange', 'Error in try catch block', err.stack);
        }
    }

    const handleStateChange = e => {
        try {
            if (e.target.selectedIndex == 0) {
                setFilteredCities(listOfCities);
            } else {
                const index = e.target.selectedIndex - 1;
                setFilteredCities(listOfCities.filter(item => item.state_id == listOfStates[index].id));
                setProvider({ ...provider, state: listOfStates[index].name });
            }
        } catch (err) {
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            // GeneralService.logError('at Provider ProviderProfile handleStateChange', 'Error in try catch block', err.stack);
        }
    }

    const handleSubmit = e => {
        e.preventDefault();
        try {
            if (!provider.title) {
                setIsError({ message: { msgBody: "Please select title", msgError: true } });
            } else if (!provider.firstName) {
                setIsError({ message: { msgBody: "Please enter FirstName", msgError: true } });
            } else if (!provider.lastName) {
                setIsError({ message: { msgBody: "Please enter LastName", msgError: true } });
            } else if (!provider.gender) {
                setIsError({ message: { msgBody: "Please select gender", msgError: true } });
            } else if (!provider.birthDate) {
                setIsError({ message: { msgBody: "Please enter birthdate", msgError: true } });
            } else if (!provider.address1) {
                setIsError({ message: { msgBody: "Please enter address1", msgError: true } });
            } else if (!provider.address2) {
                setIsError({ message: { msgBody: "Please enter address2", msgError: true } });
            } else if (!provider.city) {
                setIsError({ message: { msgBody: "Please select city", msgError: true } });
            } else if (!provider.state) {
                setIsError({ message: { msgBody: "Please select state", msgError: true } });
            } else if (!provider.pincode) {
                setIsError({ message: { msgBody: "Please enter pincode", msgError: true } });
            } else if (provider.specialities.length === 0) {
                setIsError({ message: { msgBody: "Please add speciality", msgError: true } });
            } else if (provider.languages.length === 0) {
                setIsError({ message: { msgBody: "Please add language", msgError: true } });
            } else if (provider.degrees.length === 0) {
                setIsError({ message: { msgBody: "Please add degree", msgError: true } });
            } else if (!provider.description) {
                setIsError({ message: { msgBody: "Please enter description", msgError: true } });
            } else {
                props.history.push({
                    pathname: "/counsellor/signup-step2",
                    state: {
                        provider: provider,
                    }
                });
            }
        } catch (err) {
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            // setIsLoading2(false);
            // GeneralService.logError('at Provider ProviderProfile handleSubmit', 'Error in try catch block', err.stack);
        }
    }

    // function's return
    return (
        <div>
            <GeneralNavbar history={props.history} />
            <div className='my-4 px-2'>
                <h1 id="counsellor-signup-heading" style={theme.headingMedium}>Counsellor Signup</h1>
                <div className='row'>
                    <div className='col-md-3 col-12' style={{ borderRight: "solid 1px", borderColor: "#C0C0C0" }}>
                        <ol className='px-3'>
                            <li id="li-1" className='mt-2' style={{ fontFamily: fontFamily.primary, fontSize: fontSize.md_sm, fontWeight: fontWeight.semiBold }}>Fill in your Information</li>
                            <li id="li-2" className='mt-2' style={{ fontFamily: fontFamily.primary, fontSize: fontSize.md_sm }}>Review and Submit</li>
                        </ol>
                    </div>

                    <div className='col-md-9 col-12'>
                        <h2 id="form-label" style={{ fontFamily: fontFamily.primary, fontSize: fontSize.md, fontWeight: fontWeight.semiBold }}>Fill in your Information</h2>
                        <hr style={{ color: "#C0C0C0", borderWidth: "2px" }} />

                        {isError.message.msgError ? <div className='my-3'><Message message={isError.message} /></div> : null}

                        <Form>
                            <FormGroup>
                                <Label for="title" style={theme.formBodyText}>Title</Label>
                                <Input type="select" name="title" id="title" style={theme.formInput} onChange={handleChange} defaultValue={""} value={provider.title} required>
                                    <option value="">Select one</option>
                                    {
                                        titles.map((item, index) => (
                                            <option key={index} value={item}>{item}</option>
                                        ))
                                    }
                                </Input>
                            </FormGroup>

                            <FormGroup>
                                <Label for="firstName" style={theme.formBodyText}>First Name</Label>
                                <Input type="text" name="firstName" id="firstName" style={theme.formInput} onChange={handleChange} value={provider.firstName} required />
                            </FormGroup>

                            <FormGroup>
                                <Label for="lastName" style={theme.formBodyText}>Last Name</Label>
                                <Input type="text" name="lastName" id="lastName" style={theme.formInput} onChange={handleChange} value={provider.lastName} required />
                            </FormGroup>

                            <FormGroup>
                                <Label for="email" style={theme.formBodyText}>Email</Label>
                                <Input type="email" name="email" id="email" value={provider.email} disabled style={theme.formInput} />
                            </FormGroup>

                            <FormGroup row className="ml-0">
                                <legend style={theme.formBodyText}>Gender</legend>
                                <FormGroup check>
                                    <Label check>
                                        <Input type="radio" id="gender" name="gender" value="male" onChange={handleChange} checked={provider.gender == "male" ? true : false} />{' '}
                                        Male
                                    </Label>
                                </FormGroup>
                                <FormGroup className="ml-3" check>
                                    <Label check>
                                        <Input type="radio" id="gender" name="gender" value="female" onChange={handleChange} checked={provider.gender == "female" ? true : false} />{' '}
                                        Female
                                    </Label>
                                </FormGroup>
                            </FormGroup>

                            <FormGroup>
                                <Label id="providerBirthdate" for="birthDate" className="mt-2" style={theme.formBodyText} >Birthdate </Label>
                                <Input type="date" id="birthDate" name="birthDate" max={moment().format('YYYY-MM-DD')} value={provider.birthDate} onChange={handleChange} className="form-control" style={theme.formInput} required />
                            </FormGroup>

                            <FormGroup>
                                <Label for="address1" style={theme.formBodyText}>Address 1</Label>
                                <Input type="text" style={theme.formInput} name="address1" id="address" placeholder="Flat, House no. Building, Company, Apartment" onChange={handleChange} value={provider.address1} required />
                            </FormGroup>
                            <FormGroup>
                                <Label for="address2" style={theme.formBodyText}>Address 2</Label>
                                <Input type="text" style={theme.formInput} name="address2" id="address2" placeholder="Area, Colony, Street, Sector, Village" onChange={handleChange} value={provider.address2} required />
                            </FormGroup>
                            <Row form>
                                <Col md={4}>
                                    <FormGroup>
                                        <Label for="state" style={theme.formBodyText}>State</Label>
                                        <Input type="select" id="state" name="state" style={theme.formInput} onChange={handleStateChange} value={provider.state} required>
                                            <option value="">Select</option>
                                            {
                                                listOfStates.map((item) => (
                                                    <option key={item.id} value={item.name}>{item.name}</option>
                                                ))
                                            }
                                        </Input>
                                    </FormGroup>
                                </Col>
                                <Col md={5}>
                                    <FormGroup>
                                        <Label for="city" style={theme.formBodyText}>City</Label>
                                        <Input type="select" id="city" name="city" style={theme.formInput} onChange={handleCityChange} value={provider.city} required>
                                            <option value="">Select</option>
                                            {
                                                filteredCities.map((item) => (
                                                    <option key={item.id} value={item.name}>{item.name}</option>
                                                ))
                                            }
                                        </Input>
                                    </FormGroup>
                                </Col>
                                <Col md={3}>
                                    <FormGroup>
                                        <Label for="Pincode" style={theme.formBodyText}>Pincode</Label>
                                        <Input type="text" style={theme.formInput} name="pincode" id="pincode" placeholder="123456" onChange={handleChange} value={provider.pincode} required />
                                    </FormGroup>
                                </Col>
                            </Row>

                            <FormGroup>
                                <Label for="country" style={theme.formBodyText}>Country</Label>
                                <Input type="text" name="country" id="country" disabled value={provider.country} style={theme.formInput} required />
                            </FormGroup>
                            <FormGroup>
                                <Label for="specialities" style={theme.formBodyText}>Specialities</Label>
                                {
                                    provider.specialities ?
                                        provider.specialities.map((item, index) => (
                                            <InputGroup key={index} className="mb-2">
                                                <Input type="text" value={item} disabled style={theme.formInput} />
                                                <InputGroupAddon className="ml-2" addonType="append">
                                                    <Button type="button" style={{ backgroundColor: "#9F1D1D" }} id={index} onClick={handleRemoveSpeciality}>Remove</Button>
                                                </InputGroupAddon>
                                            </InputGroup>
                                        ))
                                        : null
                                }
                                <InputGroup hidden={specialitiesSuggestion.length === 0}>
                                    <Input type="select" id="speciality" name="specialitiesInput" style={theme.formInput}>
                                        <option value="">Select</option>
                                        {
                                            specialitiesSuggestion.map((item, index) => (
                                                <option key={index} value={index}>{item}</option>
                                            ))
                                        }
                                    </Input>
                                    <InputGroupAddon className="ml-2" addonType="append">
                                        <Button type="button" id="add-btn-spce" style={{ backgroundColor: "#384E73" }} onClick={handleAddSpeciality}>Add</Button>
                                    </InputGroupAddon>
                                </InputGroup>
                            </FormGroup>

                            <FormGroup>
                                <Label for="degrees" style={theme.formBodyText} >Degrees </Label>
                                {
                                    provider.degrees
                                        ? provider.degrees.map((item, index) => (
                                            <InputGroup key={index} className="mb-2">
                                                <Input type="text" value={item} disabled style={theme.formInput} />
                                                <InputGroupAddon className="ml-2" addonType="append">
                                                    <Button type="button" style={{ backgroundColor: "#9F1D1D" }} id={index} onClick={handleRemoveDegree}>Remove</Button>
                                                </InputGroupAddon>
                                            </InputGroup>
                                        ))
                                        : null
                                }
                                <InputGroup>
                                    <Input type="text" id="degree" name="degreesInput" style={theme.formInput} onKeyDown={handleDegreeKeydown}></Input>
                                    <InputGroupAddon className="ml-2" addonType="append">
                                        <Button id="add-btn-deg" style={{ backgroundColor: "#384E73" }} onClick={handleAddDegree}>Add</Button>
                                    </InputGroupAddon>
                                </InputGroup>
                            </FormGroup>

                            <FormGroup>
                                <Label for="languages" style={theme.formBodyText}>Languages</Label>
                                {
                                    provider.languages ?
                                        provider.languages.map((item, index) => (
                                            <InputGroup key={index} className="mb-2">
                                                <Input type="text" value={item} disabled style={theme.formInput} />
                                                <InputGroupAddon className="ml-2" addonType="append">
                                                    <Button type="button" style={{ backgroundColor: "#9F1D1D" }} id={index} onClick={handleRemoveLanguages}>Remove</Button>
                                                </InputGroupAddon>
                                            </InputGroup>
                                        ))
                                        : null
                                }
                                <InputGroup hidden={languagesSuggestion.length === 0}>
                                    <Input type="select" id="languages" name="languagesInput" style={theme.formInput}>
                                        <option value="">Select</option>
                                        {
                                            languagesSuggestion.map((item, index) => (
                                                <option key={index} value={index}>{item}</option>
                                            ))
                                        }
                                    </Input>
                                    <InputGroupAddon className="ml-2" addonType="append">
                                        <Button id="add-btn-lan" type="button" style={{ backgroundColor: "#384E73" }} onClick={handleAddLanguages}>Add</Button>
                                    </InputGroupAddon>
                                </InputGroup>
                            </FormGroup>

                            <FormGroup>
                                <Label for="description" style={theme.formBodyText}>Description </Label>
                                <Input type="textarea" name="description" id="description" rows="5" value={provider.description} onChange={handleChange} required style={theme.formInput} />
                            </FormGroup>

                        </Form>

                        <p id="next-btn" className='mb-0 float-right' style={{ fontFamily: fontFamily.primary, color: colors.primary, fontSize: fontSize.lg, cursor: 'pointer' }} onClick={(e) => handleSubmit(e)}>Next <i className="fas fa-arrow-circle-right"></i></p>

                    </div>

                </div>
            </div>
            <Footer />
        </div>
    )
}

export default ProviderSignUpStep1;